import React from 'react';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AppTabs } from '../shared/tabs/AppTabs';
import { AppTabPanel } from '../shared/tabs/AppTabPanel';
import { AccountGeneralTabContent } from './components/AccountGeneralTabContent';
import { AccountUsersTabContent } from './components/AccountUsersTabContent';
import { AccountStorageTabContent } from './components/AccountStorageTabContent';
import { resolveCompanyLogoUrl } from '../../../../helpers/company-helper';

export const AccountSettingsScreen = () => {
    const company = useSelector((state) => state.company);
    const [activeTab, setActiveTab] = React.useState('general');

    const companyLogoUrl = React.useMemo(() => {
        return company?.logoUrl || resolveCompanyLogoUrl(company?.settings || {});
    }, [company?.logoUrl, company?.settings]);

    const tabs = React.useMemo(() => ([
        { key: 'general', label: 'General' },
        { key: 'users', label: 'Usuarios' },
        { key: 'storage', label: 'Almacenamiento' },
    ]), []);

    const formatBytes = (bytes) => {
        if (!bytes) return '-';
        return (bytes / (1024 * 1024)).toFixed(2);
    };

    return (
        <div className="row">
            <div className="col-xxl-4 col-xl-6">
                <div className="card stretch stretch-full">
                    <div className="card-body">
                        <div className="mb-4 text-center">
                            <div className="wd-150 ht-150 mx-auto mb-3 rounded-circle border border-5 border-gray-3 d-flex align-items-center justify-content-center overflow-hidden bg-light">
                                {companyLogoUrl ? (
                                    <img src={companyLogoUrl} alt={company?.name || 'Empresa'} className="w-100 h-100 object-fit-cover" />
                                ) : (
                                    <i className="feather-briefcase text-primary fs-1"></i>
                                )}
                            </div>
                            <div className="mb-4">
                                <span className="fs-14 fw-bold d-block">{company?.name || 'Compañía sin nombre'}</span>
                                <span className="fs-12 fw-normal text-muted d-block">Tenant ID: {company?.id || '-'}</span>
                            </div>

                            <div className="fs-12 fw-normal text-muted text-center d-flex flex-wrap gap-3 mb-4">
                                <div className="flex-fill py-3 px-4 rounded-1 d-none d-sm-block border border-dashed border-gray-5">
                                    <h6 className="fs-15 fw-bolder">{company?.subscription || '-'}</h6>
                                    <p className="fs-12 text-muted mb-0">Suscripción</p>
                                </div>
                                <div className="flex-fill py-3 px-4 rounded-1 d-none d-sm-block border border-dashed border-gray-5">
                                    <h6 className="fs-15 fw-bolder">{formatBytes(company?.storage)} MB</h6>
                                    <p className="fs-12 text-muted mb-0">Almacenamiento</p>
                                </div>
                                <div className="flex-fill py-3 px-4 rounded-1 d-none d-sm-block border border-dashed border-gray-5">
                                    <h6 className="fs-15 fw-bolder">
                                        <span className={`badge ${company?.adminEmailVerified ? 'bg-soft-success text-success' : 'bg-soft-warning text-warning'}`}>
                                            {company?.adminEmailVerified ? 'VERIFICADO' : 'PENDIENTE'}
                                        </span>
                                    </h6>
                                    <p className="fs-12 text-muted mb-0">Email admin</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-xxl-8 col-xl-6 px-xl-3 px-xxl-4">
                <div className="card border-top-0">
                    <div className="nav nav-tabs pt-0 pb-0">
                        <AppTabs
                            tabs={tabs}
                            activeTab={activeTab}
                            onChange={setActiveTab}
                            navClassName="nav nav-tabs flex-wrap w-100 customers-nav-tabs"
                            itemClassName="nav-item border-top border-end"
                        />
                    </div>

                    <div className="tab-content">
                        <AppTabPanel isActive={activeTab === 'general'} className="p-4">
                            <AccountGeneralTabContent />
                        </AppTabPanel>

                        <AppTabPanel isActive={activeTab === 'users'} className="p-4">
                            <AccountUsersTabContent />
                        </AppTabPanel>

                        <AppTabPanel isActive={activeTab === 'storage'} className="p-4">
                            <AccountStorageTabContent />
                        </AppTabPanel>
                    </div>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={2500}
                hideProgressBar
                newestOnTop
                closeOnClick
                pauseOnHover
                draggable
                theme="light"
            />
        </div>
    );
};
